import ChatInputNode from './nodes/ChatInputNode';
import OpenAINode from './nodes/OpenAINode';
import ChatOutputNode from './nodes/ChatOutputNode';
import InitializerNode from './nodes/InitializerNnode';
import EndNode from './nodes/EndNode';
import ConditionalNode from './nodes/ConditionalNode';
import CarryForwardNode from './nodes/CarryForwardNode';

const nodeTypes = {
   initializer_node: InitializerNode,
   input_node: ChatInputNode,
   openai_chat_node: OpenAINode,
   output_node: ChatOutputNode,
   end_node: EndNode,
   conditional_node: ConditionalNode,
   carry_forward_node:CarryForwardNode,
   
};

export default nodeTypes;
